// Sheet open/close state for the shell's notification bell.
//
// Split out of `NotificationBell.tsx` for one concrete reason: `react-refresh`
// only permits a component module to export components, so a `useState` wrapper
// living next to the component breaks Fast Refresh for everyone editing it.
// The hook is state, not UI, and this is where state belongs.

import { useState } from "react";

export interface NotificationBellState {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Owner of the sheet's open state.
 *
 * `MobileHeader` and `TopBar` each call this once and hand the result to their
 * `<NotificationBell />`. One piece of state per header would be two chances
 * for the badge and the sheet to disagree about whether the sheet is open —
 * and they are the same logical control rendered for two viewports, not two
 * controls.
 */
export function useNotificationBell(): NotificationBellState {
  const [open, setOpen] = useState(false);
  return { open, onOpenChange: setOpen };
}
